import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiAxios from "helpers/apiAxios";
import { toast } from "react-toastify";

const projectUrl = `/crm/reports`;

export const getCrmDashboardData = createAsyncThunk(
  "ReportCrmDashboard/getCrmDashboardData",
  async (params) => {
    try {
      const response = await apiAxios.get(`${projectUrl}/dashboard`, { params })
      return response.data
    }
    catch(error) {
      throw new Error(error.message)
    }
  }
)

const isRejectedAction = (action) => action.type.startsWith("report_crm_dashboard/") && action.type.endsWith("/rejected");
const crmDasboardSlice = createSlice({
  name: "report_crm_dashboard",
  initialState: {
    loading: false,
    exporting: false,
    dashboardData: []
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCrmDashboardData.fulfilled, (state, action) => {
        state.dashboardData = action.payload
      })
      .addMatcher(
        isRejectedAction,
        (state, action) => {
          state.loading = false;
          toast.error(action.payload?.message || action.payload?.error || action?.error?.message)
        }
      );
  }
})

//export const {} = crmDasboardSlice.actions

export default crmDasboardSlice.reducer;